import { render, staticRenderFns } from "./BaseNotes.vue?vue&type=template&id=68a0fce1&v-if=notes%20%26%26%20notes.length%20%3E%200&"
import script from "./BaseNotes.vue?vue&type=script&lang=js&"
export * from "./BaseNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports